<template><div><h2 class="big-title">vux!vue</h2>
<p align="left">
  <a href="https://www.npmjs.com/package/vux-loader">
    <img src="https://img.shields.io/npm/v/vux-loader.svg?style=flat-square" alt="">
  </a>
  <a href="https://www.npmjs.com/package/vux-loader">
    <img src="https://img.shields.io/npm/dm/vux-loader.svg?style=flat-square" alt="">
  </a>
</p>
<h3>介绍</h3>
<p><code>vux-loader</code>工具的作用是对<code>.vue</code>代码进行预处理，不限于 vux 组件库。</p>
<p>它是针对<code>webpack+vue-loader</code>项目的工程化工具，简化了webpack插件和loader的使用和编写，支持在vue-loader处理之前进行预处理，同时内置对vux组件专用的配置和优化插件。</p>
<p>当然除了.vue文件外，你还可以对js文件进行预处理。说好的处理.vue文件，为什么连<code>js</code>文件也不放过呢？因为只有处理js才能实现理想工程化。举个例子，如果用户需要在<code>main.js</code>中调用vux的plugin，他需要这样做：</p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> AlertPlugin <span class="hljs-keyword">from</span> <span class="hljs-string">'vux/src/plugins/Alert'</span>
<span class="hljs-keyword">import</span> ToastPlugin <span class="hljs-keyword">from</span> <span class="hljs-string">'vux/src/plugins/Toast'</span>
</code></pre>
<p>虽然路径不长，但是看着相当不和谐，为了简化这个操作vux提供了更简洁的写法：</p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { AlertPlugin, ToastPlugin } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p>这个操作即是通过<code>js-parser</code>插件解析main.js里的<code>import</code>语法来实现的，最终进入babel的代码和上面单独引入一致。</p>
<p>这个工具也许会帮你进一步打开<code>Vue</code>项目工程化的思路。</p>
<p class="tip">
  作为通用工具，即使你没有使用Vux，依然可以使用它来进行各种代码处理。
  <br>
  目前支持 vue-loader@>9.x, 低版本没有具体测试。
  <br>
  `vux!vue`的loader写法只兼容webpack@1.x，为了兼容webpack@2.x，处理后的loader配置是`vux-loader!vue-loader`
</p>
<h3>实现方式</h3>
<p>说明一下<code>vux-loader</code>是如何和<code>vue-loader</code><del>搞基</del>配合的，vue-loader的issue里不少同学遇到预处理.vue的问题。</p>
<p>如果你看过<code>webpack</code>loader的介绍，理论上说如果需要自己手动先处理代码再传入<code>vue-loader</code>,你只需要这样对loader做配置: <code>vue-loader!my-loader</code>。但是如果你试过，就知道这个目前行不通。<code>vue-loader</code>不会接收上一个loader的source进行处理，因为.vue文件的特殊性，它直接生成了loader string进入下一个处理，处理后的结果大概是这样的：</p>
<pre class="hljs"><code><span class="hljs-comment">/* styles */</span>
<span class="hljs-built_in">require</span>(<span class="hljs-string">"!!vue-style-loader!css-loader!vue-loader/lib/style-rewriter?id=data-v-20d7ba9a!vue-loader/lib/selector?type=styles&amp;index=0!./index.vue"</span>)

<span class="hljs-comment">/* script */</span>
__vue_exports__ = <span class="hljs-built_in">require</span>(<span class="hljs-string">"!!babel-loader!vue-loader/lib/selector?type=script&amp;index=0!./index.vue"</span>)

<span class="hljs-comment">/* template */</span>
<span class="hljs-keyword">var</span> __vue_template__ = <span class="hljs-built_in">require</span>(<span class="hljs-string">"!!vue-loader/lib/template-compiler?id=data-v-20d7ba9a!vue-loader/lib/selector?type=template&amp;index=0!./index.vue"</span>)
</code></pre>
<p>那么vue-loader提供了自定义loader string的选项，直接配置可否呢，<a href="https://github.com/vuejs/vue-loader/issues/531">#531</a>，直接配置会破坏原来的loader参数，导致不能Live reload。</p>
<p>那么最终能想到的就是直接修改<code>vue-loader</code>生成的代码，这样既不会影响<code>vue-loader</code>原来的逻辑，也能自由控制。</p>
<p>最终实现方式是前置<code>vux-loader</code>即：<code>vux-loader!vue-loader</code>，vux-loader将vue-loader生成的代码二次处理，分割loader string并(强行)插入vux的 template-loader, style-loader, script-loader，那么你就能理解vux-loader的配置方式了，在3大基本loader里获取到vux-loader的插件配置列表逐个做处理就行了。</p>
<p>上面的代码强行处理后是这样的：</p>
<pre class="hljs"><code><span class="hljs-comment">/* styles */</span>
<span class="hljs-built_in">require</span>(<span class="hljs-string">"!!vue-style-loader!css-loader!vue-loader/lib/style-rewriter?id=data-v-20d7ba9a!./../../../../vux-loader/src/style-loader.js!vue-loader/lib/selector?type=styles&amp;index=0!./index.vue"</span>)

<span class="hljs-comment">/* script */</span>
__vue_exports__ = <span class="hljs-built_in">require</span>(<span class="hljs-string">"!!babel-loader!vue-loader/lib/selector?type=script&amp;index=0!./../../../../vux-loader/src/script-loader.js!./index.vue"</span>)

<span class="hljs-comment">/* template */</span>
<span class="hljs-keyword">var</span> __vue_template__ = <span class="hljs-built_in">require</span>(<span class="hljs-string">"!!vue-loader/lib/template-compiler?id=data-v-20d7ba9a!./../../../../vux-loader/src/template-loader.js!vue-loader/lib/selector?type=template&amp;index=0!./index.vue"</span>)
</code></pre>
<p>原理就是这么简单（但是处理时还是遇到一些问题），为了方便使用，编写了常用的一些插件。</p>
<p>至于<code>js-parser</code>就只是在<code>babel-loader</code>前加上了<code>vux-loader</code>的<code>js-loader</code>。</p>
<p>而所有的loader, plugins设置都是在<code>vux-loader</code>的<code>merge</code>方法里来完成。</p>
<h3>实际使用场景</h3>
<p>我们可以使用<code>vux-loader</code>做一些很有意思的事。<br>
比如 <a href="https://github.com/vuejs/vue-loader/issues/542">#542</a> 提到的根据当前feature为判断要输出哪一部分代码，现在已经直接支持，请看 <code>template-feature-switch</code>部分。</p>
<p>对于公用组件而言，完全可以实现构建时进行组件瘦身，只保留使用到的代码。</p>
<p>当然如果你愿意，你完全可以自己实现一门语言。</p>
<h2>安装</h2>
<pre class="hljs"><code>npm install vux-loader --save-dev
</code></pre>
<h2>使用</h2>
<p>为了减少使用成本，只需要调用<code>merge</code>方法对原来<code>webpack</code>配置进行操作：</p>
<pre class="hljs"><code><span class="hljs-keyword">const</span> webpackConfig = {} <span class="hljs-comment">// 原来的webpack配置</span>

<span class="hljs-keyword">const</span> vuxLoader = <span class="hljs-built_in">require</span>(<span class="hljs-string">'vux-loader'</span>)

<span class="hljs-built_in">module</span>.exports = vuxLoader.merge(webpackConfig, {
  <span class="hljs-attr">options</span>: {},
  <span class="hljs-attr">plugins</span>: [{
    <span class="hljs-attr">name</span>: <span class="hljs-string">'vux-ui'</span>
  }]
})
</code></pre>
<p class="warning">
  更新配置后需要重启npm run dev命令
</p>
<h3>Options</h3>
<ul>
<li><code>env</code> 非必选，定义当前环境变量，只在vux-loader里使用，用来判断哪些插件需要被执行(如果plugin有定义envs的话)，目的是实现一份配置多个环境使用。</li>
</ul>
<h3>Plugins</h3>
<p>插件为一个数组列表，根据需要可以添加你需要的插件，插件名为必须，有些组件不需要额外配置选项。</p>
<p>公用参数为:</p>
<ul>
<li><code>name</code> <code>必须</code>，插件名字</li>
<li><code>envs</code> <code>非必须</code>，数组，当前插件在哪些环境变量里执行，不定义则默认执行</li>
</ul>
<p>下面的插件配置代码将省略 <code>plugins:[]</code>的书写。</p>
<h4>script-parser</h4>
<blockquote>
<p>script代码替换处理</p>
</blockquote>
<pre class="hljs"><code>[{
 <span class="hljs-attr">name</span>: <span class="hljs-string">'script-parser'</span>,
 <span class="hljs-attr">fn</span>: <span class="hljs-function"><span class="hljs-keyword">function</span> (<span class="hljs-params">source</span>) </span>{
   <span class="hljs-keyword">return</span> source.replace(<span class="hljs-string">'VARIABLE'</span>, <span class="hljs-string">'v2'</span>)
 }
}]
</code></pre>
<h4>style-parser</h4>
<blockquote>
<p>style代码替换处理</p>
</blockquote>
<pre class="hljs"><code>[{
 <span class="hljs-attr">name</span>: <span class="hljs-string">'style-parser'</span>,
 <span class="hljs-attr">fn</span>: <span class="hljs-function"><span class="hljs-keyword">function</span> (<span class="hljs-params">source</span>) </span>{
   <span class="hljs-keyword">return</span> source.replace(<span class="hljs-string">'black'</span>, <span class="hljs-string">'white'</span>)
 }
}]
</code></pre>
<h4>template-parser</h4>
<blockquote>
<p>template代码替换处理</p>
</blockquote>
<blockquote>
<p>适用于对<code>&lt;template&gt;&lt;/template&gt;</code>模板代码做自定义处理<br>
适用于某些更改不频繁但非服务端配置的文字，可能调用多次，也可能手动更改或者批量替换相对麻烦</p>
<p>同样你也可以用来从接口获取最新配置替换特定的占位字符</p>
<p>当然也适用于在源码中对<code>pm</code>进行吐槽(千万要记得production环境要有配置，否则可能会上新闻。)</p>
</blockquote>
<ul>
<li>name 插件名字， <code>template-parser</code></li>
<li>replaceList 非必须，正则匹配列表，将直接调用 <code>replace</code> 方法进行替换</li>
<li>fn 非必须，相比params更灵活的方法，可以对字符串进行处理后返回</li>
</ul>
<p>插件配置：</p>
<pre class="hljs"><code>[
  name: <span class="hljs-string">"template-parser"</span>,
  <span class="hljs-attr">replaceList</span>: [{
    <span class="hljs-attr">test</span>: <span class="hljs-regexp">/DeathToPM/g</span>,
    <span class="hljs-attr">replaceString</span>: <span class="hljs-string">'微博-随时随地发现新鲜事'</span>
  }, {
    <span class="hljs-attr">test</span>: <span class="hljs-regexp">/呵呵我们压根没有底线/g</span>,
    <span class="hljs-attr">replaceString</span>: <span class="hljs-string">'我是有底线的'</span>
  }],
  <span class="hljs-attr">fn</span>: <span class="hljs-function"><span class="hljs-keyword">function</span> (<span class="hljs-params">templateSource</span>) </span>{
    <span class="hljs-keyword">return</span> templateSource.replace(<span class="hljs-string">'智障'</span>, <span class="hljs-string">'机智'</span>)
  }
]
</code></pre>
<h4>js-parser</h4>
<blockquote>
<p>项目里js文件处理，在babel-loader前进行处理</p>
</blockquote>
<pre class="hljs"><code>[{
 <span class="hljs-attr">name</span>: <span class="hljs-string">'js-parser'</span>,
 <span class="hljs-attr">fn</span>: <span class="hljs-function"><span class="hljs-keyword">function</span> (<span class="hljs-params">source</span>) </span>{
   <span class="hljs-keyword">return</span> source.replace(<span class="hljs-string">'black'</span>, <span class="hljs-string">'white'</span>)
 }
}]
</code></pre>
<h4>template-feature-switch</h4>
<p>实现根据变量切换template代码</p>
<p>参数：</p>
<ul>
<li><code>features</code>，变量列表，值只能为true或者false</li>
</ul>
<pre class="hljs"><code>{
  <span class="hljs-attr">name</span>: <span class="hljs-string">'template-feature-switch'</span>,
  <span class="hljs-attr">features</span>: {
    <span class="hljs-attr">feature1</span>: <span class="hljs-literal">true</span>,
    <span class="hljs-attr">feature2</span>: <span class="hljs-literal">false</span>
  }
}
</code></pre>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">on</span> <span class="hljs-attr">feature</span>=<span class="hljs-string">"feature1"</span>&gt;</span>
      AWESOME FEATURE 1 is ON
    <span class="hljs-tag">&lt;/<span class="hljs-name">on</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">off</span> <span class="hljs-attr">feature</span>=<span class="hljs-string">"feature1"</span>&gt;</span>
      AWESOME FEATURE 1 is OFF
    <span class="hljs-tag">&lt;/<span class="hljs-name">off</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
</code></pre>
<p>那么当 feature1 为 true时，将输出 <code>AWESOME FEATURE 1 is ON</code>, 反之则输出 <code>AWESOME FEATURE 1 is OFF</code>。注意<code>on</code>标签内不限定内容，可以为任何标签代码块，但<code>避免在on off 里面再嵌套 on off</code></p>
<h4>vux-ui</h4>
<p class="warning">
  vux组件的配套工具，如果没有使用vux, 不需要添加。
</p>
<p>如果配合<code>vux</code>使用，需要手动启用。默认不需要设置选项。</p>
<p>该插件做了以下处理：</p>
<ul>
<li>配置<code>babel</code>编译 vux 的js源码</li>
<li>修改vue-loader为 <code>vux-loader!vue-loader</code></li>
<li><code>import</code>组件调用解析为单组件引入</li>
</ul>
<pre class="hljs"><code>{
  name: 'vux-ui'
}
</code></pre>
<p>那么你就可以很方便地引入组件了：</p>
<pre class="hljs"><code>// 0.x
import Group from 'vux/src/components/group'
import Cell from 'vux/src/components/cell'

// 2.x
import { Group, Cell } from 'vux'
</code></pre>
<h4>i18n</h4>
<p class="warning">
请使用正确的 yml 格式。冒号和值之间是有一个空格的，错误的格式将无法生效。
</p>
<pre class="hljs"><code><span class="hljs-attr">on-show:</span>
<span class="hljs-attr">  en:</span> <span class="hljs-string">emits</span> <span class="hljs-string">when</span> <span class="hljs-string">popup</span> <span class="hljs-string">shows</span>
<span class="hljs-attr">  zh-CN:</span> <span class="hljs-string">弹窗显示时触发</span>
</code></pre>
<ol>
<li>
<p>如果你只是调用中文语言的vux组件，那么你不需要做任何配置。</p>
</li>
<li>
<p>如果你需要调用英文语言的vux组件，需要配置语言</p>
</li>
</ol>
<pre class="hljs"><code>{
  <span class="hljs-attr">name</span>: <span class="hljs-string">'i18n'</span>,
  <span class="hljs-attr">vuxStaticReplace</span>: <span class="hljs-literal">true</span>,
  <span class="hljs-attr">vuxLocale</span>: <span class="hljs-string">'en'</span>
}
</code></pre>
<ol start="3">
<li>如果你想和demo站点一样可以写<code>i18n</code>block，并且需要动态切换语言，那么需要配置插件抽取i18n的内容，并设置非静态替换</li>
</ol>
<pre class="hljs"><code>{
  <span class="hljs-attr">name</span>: <span class="hljs-string">'i18n'</span>,
  <span class="hljs-attr">vuxStaticReplace</span>: <span class="hljs-literal">false</span>,
  <span class="hljs-attr">staticReplace</span>: <span class="hljs-literal">false</span>,
  <span class="hljs-attr">extractToFiles</span>: <span class="hljs-string">'src/locales/components.yml'</span>,
  <span class="hljs-attr">localeList</span>: [<span class="hljs-string">'en'</span>, <span class="hljs-string">'zh-CN'</span>]
}
</code></pre>
<p>然后你就可以引用<code>vuex-i18n</code>插件实现多语言切换了。</p>
<p>参考 <a href="https://github.com/airyland/vux/blob/254574ef30a8c4d341feb7d2ff8245792657bda2/src/main.js#L84-L96">main.js</a> 及 <a href="https://www.npmjs.com/package/vuex-i18n">vuex-i18n 文档</a>(仅当参考，你也可以使用其他i18n插件)。</p>
<h4>less-theme</h4>
<p class="warning">
注意，path所在文件必须是简单的less变量对，不能import其他文件或者引入变量。
</p>
<blockquote>
<p>less 变量设置和替换</p>
</blockquote>
<blockquote>
<p>适用于全局变量替换,  方便切换主题<br>
这意味着，你不再需要为每个页面引入全局的less文件了，你只需要设置lang为less就可以直接使用变量了</p>
</blockquote>
<pre class="hljs"><code>&lt;style lang=&quot;less&quot;&gt;
.info {
 color: @font-size;
}
&lt;/style&gt;
</code></pre>
<p>插件配置：</p>
<pre class="hljs"><code>{
  <span class="hljs-attr">name</span>: <span class="hljs-string">'less-theme'</span>,
  <span class="hljs-attr">path</span>: <span class="hljs-string">'src/styles/theme.less'</span>
}
</code></pre>
<h4>duplicate-style</h4>
<blockquote>
<p>css 重复代码清除</p>
</blockquote>
<p class="tip">
  建议使用vux组件的用户使用，因为vux直接引用less，最终构建的css文件确实会有冗余。
</p>
<blockquote>
<p>在webpack 构建完成后对生成的css文件使用cssnano进行重复样式清除。建议只在production环境下开启，因为dev环境没有必要。</p>
</blockquote>
<pre class="hljs"><code>{
  <span class="hljs-attr">name</span>: <span class="hljs-string">'duplicate-style'</span>,
  <span class="hljs-attr">events</span>: {
    <span class="hljs-attr">done</span>: <span class="hljs-function"><span class="hljs-keyword">function</span> (<span class="hljs-params"></span>) </span>{
      <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'done!'</span>)
    }
  }
}
</code></pre>
<h4>html-build-callback</h4>
<blockquote>
<p>html文件处理事件回调</p>
</blockquote>
<blockquote>
<p>适用于在写入html(一般为index.html)文件前进行内容修改，比如替换特定内容<br>
比如写入js配置变量，改变cdn域名，将manifest文件直接写入html以减少请求等</p>
</blockquote>
<pre class="hljs"><code>{
  <span class="hljs-attr">name</span>: <span class="hljs-string">'html-build-callback'</span>,
  <span class="hljs-attr">events</span>: {
   <span class="hljs-string">'after-html-processing'</span>: <span class="hljs-function"><span class="hljs-keyword">function</span> (<span class="hljs-params">data, cb</span>) </span>{
      data.html += <span class="hljs-string">'magic footer'</span>
      cb(<span class="hljs-literal">null</span>, data)
   }
  }
}
</code></pre>
<p>可用事件请参考 <a href="https://www.npmjs.com/package/html-webpack-plugin">html-webpack-plugin</a></p>
<h4>build-done-callback</h4>
<blockquote>
<p>构建完成事件回调<br>
本质上是在webpack plugin的 done 事件后触发</p>
</blockquote>
<pre class="hljs"><code>{
 <span class="hljs-attr">name</span>: <span class="hljs-string">'build-done-callback'</span>,
 <span class="hljs-attr">fn</span>: <span class="hljs-function"><span class="hljs-keyword">function</span> (<span class="hljs-params"></span>) </span>{
   <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'done!'</span>)
 }
}
</code></pre>
<h3>使用案例</h3>
<h4>统一引入less(sass)变量</h4>
<p>如果你翻看<code>vue-loader</code>的issue, 就会发现不少同学在说，为什么sass, less 变量不能全局使用，需要在每个.vue组件里引入，这个很重复，有没有办法解决。目前除了在webpack里定义路径<code>alias</code>外没有其他方法。但是有了<code>vux-loader</code>，你可以用<code>style-parser</code>在每个<code>.vue</code>文件的style前面加上变量的引入了，只要一句代码。</p>
<pre class="hljs"><code>{
  name: 'style-parser',
  fn: function (source) {
    return &quot;@import '../styles/variable.less'\n&quot; + source // 你可以根据this.resourcePath 来确定是否要引入以及引入的相对路径
  }
}
</code></pre>
<h4>减少重复代码</h4>
<p><code>vux</code>的组件有几十个，同样demo也有几十个，因为webpack并不支持require变量，那么在main里中实现每个组件异步加载都需要这样：</p>
<pre class="hljs"><code><span class="hljs-keyword">const</span> routes = [
  {
    <span class="hljs-attr">path</span>: <span class="hljs-string">'/component/actionsheet'</span>,
    <span class="hljs-attr">component</span>: <span class="hljs-function"><span class="hljs-keyword">function</span> (<span class="hljs-params">resolve</span>) </span>{
      <span class="hljs-built_in">require</span>([<span class="hljs-string">'./demos/Actionsheet'</span>], resove)
    }
  }
]
</code></pre>
<p>作为懒人，写几十次这样的代码是一件比较烦人的事，作为热爱地球的人，这样也很不环保，但是有了<code>vux-loader</code>, 我们可以这样：</p>
<pre class="hljs"><code><span class="hljs-keyword">const</span> routes = []
</code></pre>
<p>然后在<code>js-parser</code>里获取列表数组直接替换， 并且可以调用webpack的<code>this.addDependency</code>添加依赖实现修改列表时自动<code>reload</code>。从此添加删除组件只要加上或者删除名字就可以了，真是<del>懒</del>机智。</p>
<pre class="hljs"><code> {
  <span class="hljs-attr">name</span>: <span class="hljs-string">'js-parser'</span>,
  <span class="hljs-attr">test</span>: <span class="hljs-regexp">/main\.js/</span>,
  <span class="hljs-attr">fn</span>: <span class="hljs-function"><span class="hljs-keyword">function</span> (<span class="hljs-params">source</span>) </span>{
    <span class="hljs-keyword">this</span>.addDependency(demoPath)
    <span class="hljs-keyword">let</span> list = fs.readFileSync(demoPath, <span class="hljs-string">'utf-8'</span>)
    list = <span class="hljs-built_in">JSON</span>.parse(list)
    <span class="hljs-keyword">let</span> str = []
    list.forEach(<span class="hljs-function"><span class="hljs-params">one</span> =&gt;</span> {
      str.push(<span class="hljs-string">`{
path: '/component/<span class="hljs-subst">${toDash(one)}</span>',
component: function (resolve) {
require(['./demos/<span class="hljs-subst">${one}</span>.vue'], resolve)
}
}`</span>)
    })

    str = <span class="hljs-string">`[<span class="hljs-subst">${str.join(<span class="hljs-string">',\n'</span>)}</span>]`</span>
    source = source.replace(<span class="hljs-string">'const routes = []'</span>, <span class="hljs-string">'const routes = '</span> + str)
    <span class="hljs-keyword">return</span> source
  }
}
</code></pre>
<h4>实现import语法转换</h4>
<p>vux是没有main入口文件的，因此需要把import语句转换成单个组件引入。但是因为对语法树分析比较烦，能用正则替换的当然就是用正则替换，简单粗暴实用。具体可以看源码。</p>
<h4>开源组件多语言支持</h4>
<p>如果以js方式分发，一般默认一个语言，用户可以加上另外的语言包，但是代码里必不可少存在相应的转换函数，对于只需要单语言的人来是个浪费和繁琐。要么所有一起打包，这个也极浪费。要么一个一个打包，这样又失去了动态多语言支持。</p>
<p>于是<code>vux</code>在<code>vux-loader</code>的支持下实现了<code>使用时构建</code>，无论是静态输出和动态支持。</p>
<h3>Bug 反馈 &amp;&amp; 功能建议</h3>
<p>请到<a href="https://github.com/airyland/vux-loader/issues">https://github.com/airyland/vux-loader/issues</a></p>
<h3>Todo</h3>
<ul>
<li>[ ] 支持各个插件的异步返回形式</li>
<li>[ ] 在插件中提供webpack的 this 参数</li>
</ul>
</div></template><script>
export default {
  head: {"title":" | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// vux-loader-5.vue?79c75617